import React from 'react';
import Button from '../Button/Button';
import './FinishGame.css';

const FinishGame = (props) => {

    return (
        <div>
            <img src={props.src} className='bigBg' alt=' ' />
            <Button className='GamePrev' onClick={() => props.onClick('prev')} />
            <Button className={(props.lang === 'fin') ? 'PlayAgainFin' : 'PlayAgainRus'} onClick={() => props.onClick('toStart')}  />

        </div>
    );
};

export default FinishGame;